import { Linkedin, Mail, Globe, AtSign, Layout, Maximize2 } from 'lucide-react';
import { config } from '../data/config';
import { useViewMode } from '../context/ViewModeContext';

export const Footer = () => {
  const { mode, designVersion, toggleMode, toggleDesignVersion } = useViewMode();

  const links = [
    {
      url: config.links.linkedin,
      icon: Linkedin,
      label: 'LinkedIn'
    },
    {
      url: config.links.website,
      icon: Globe,
      label: 'Site web'
    },
    {
      url: config.links.bluesky,
      icon: AtSign,
      label: 'Bluesky'
    },
    {
      url: config.links.email ? `mailto:${config.links.email}` : undefined,
      icon: Mail,
      label: 'Email'
    },
  ].filter(link => link.url);

  return (
    <footer className="bg-slate-900 text-white py-12 px-6 mt-20">
      <div className="max-w-6xl mx-auto flex flex-col items-center">

        {/* Toggle Mode & Design */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8">
          <button
            onClick={toggleMode}
            className="flex items-center gap-2 px-4 py-2 bg-slate-800 rounded-full text-slate-300 hover:text-white hover:bg-slate-700 transition-all text-xs border border-slate-700 w-full sm:w-auto justify-center"
          >
            {mode === 'modal' ? <Maximize2 size={14} /> : <Layout size={14} />}
            <span>Mode {mode === 'modal' ? 'Page' : 'Modale'}</span>
          </button>

          <button
            onClick={toggleDesignVersion}
            className={`
              flex items-center gap-2 px-4 py-2 rounded-full text-xs font-bold transition-all border w-full sm:w-auto justify-center
              ${designVersion === 'cyberpunk'
                ? 'bg-cyan-500/10 border-cyan-500/50 text-cyan-400 hover:bg-cyan-500/20 shadow-[0_0_15px_rgba(6,182,212,0.2)]'
                : 'bg-slate-800 border-slate-700 text-slate-300 hover:text-white hover:bg-slate-700'
              }
            `}
          >
            <span>Design: {designVersion === 'cyberpunk' ? 'Cyberpunk ⚡' : 'Standard 🏛️'}</span>
          </button>
        </div>

        {/* Book Download & Order Bridge */}
        <div className="mb-8 p-6 bg-slate-800/80 border border-slate-700/80 rounded-2xl max-w-xl text-center shadow-lg w-full">
          <h4 className="text-lg font-bold text-white mb-2">📚 Le Petit Dictionnaire Énervé du PM</h4>
          <p className="text-slate-300 text-sm mb-4">
            Disponible en version numérique gratuite (PDF, EPUB) ou en version papier brochée.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <a
              href="https://brou.pm/book_dico_pm"
              className="px-4 py-2 bg-rose-500 hover:bg-rose-600 text-white font-medium text-xs rounded-xl transition-all shadow-sm flex items-center gap-1.5"
            >
              <span>📥</span>
              <span>Obtenir l'Ebook gratuit</span>
            </a>
            <a
              href="https://amzn.eu/d/gjgvnVf"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white font-medium text-xs rounded-xl transition-all border border-slate-600 flex items-center gap-1.5"
            >
              <span>📦</span>
              <span>Commander sur Amazon</span>
            </a>
          </div>
        </div>

        <p className="text-slate-300 mb-2">
          © 2025 {config.site.author}
        </p>
        <p className="text-slate-400 text-sm mb-6">
          {config.site.collection}
        </p>

        {links.length > 0 && (
          <div className="flex justify-center gap-6">
            {links.map((link) => (
              <a
                key={link.label}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-white transition-colors flex items-center gap-2"
                aria-label={link.label}
              >
                <link.icon size={20} />
                <span className="hidden sm:inline text-sm">{link.label}</span>
              </a>
            ))}
          </div>
        )}
      </div>
    </footer>
  );
};
